__turbopack_context__.v({
  "className": "inter_2fe1ab3d-module__-T-KAq__className",
  "variable": "inter_2fe1ab3d-module__-T-KAq__variable",
});
